<i18n>
{
	"en": {
		"addFilter": "Add filter",
		"advancedSearch": "Advanced Search",
		"allLocations": "All locations",
		"cancelled": "Cancelled",
		"consigneeReference": "Consignee Reference",
		"customersReference": "Customers Reference",
		"deliveryStatus": "Delivery Status",
		"economicalStatus": "Economical Status",
		"economicalStatusSelected": "All economical status | {count} economical status selected | {count} economical status selected",
		"editSearch": "Edit search",
		"fromDespatchParty": "Despatch Party",
		"goodsTypes": "Goods Types",
		"incomplete": "Incomplete",
		"invoiced": "Invoiced",
		"loading": "Loading...",
		"notDelivered": "Not Delivered",
		"notPickedUp": "Not Picked Up",
		"notSettled": "Not Settled",
		"numberOfPallets": "Pallets",
		"onlyDelivered": "Only Delivered",
		"onlyPickedUp": "Only Picked Up",
		"orderDetails": "Order Details",
		"orderType": "Order Type",
		"pickupStatus": "Pickup Status",
		"poReference": "PO Reference",
		"recorded": "Recorded",
		"references": "References",
		"referencesSelected": "All references | {count} reference selected | {count} references selected",
		"resetSearch": "Reset Search",
		"saveSearch": "Save this search",
		"search": "Search",
		"searchForLocation": "Search for location",
		"searchForOrders": "Search for Orders",
		"searchPlaceholder": "Search text",
		"selectDate": "Select date",
		"selectEconomicalStatus": "Select economical status",
		"selectReferences": "Select references",
		"sendersReference": "Senders Reference",
		"settled": "Settled",
		"showAny": "Show Any",
		"status": "Status",
		"toDeliveryParty": "Delivery Party",
		"failedToFetch": "Failed to search for orders",
		"selectOrdersFromArea": "Select orders from area",
		"selectOrdersToArea": "Select orders to area",
		"etd": "ETD",
		"eta": "ETA",
		"etx": "ETD / ETA","selectOrderStatus": "Select Status",
		"orderStatusSelected": "All statuses | {count} status selected | {count} statuses selected",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"waybillNumber": "Waybill Number",
		"allWaybillNumbers": "All waybill numbers",
		"inboundEdiFilterLabel": "Only inbound EDI from",
		"inboundEdiFilterPlaceholder": "EDI from",
		"deviationFilterLabel": "Deviation"
	},
	"no": {
		"addFilter": "Legg til filter",
		"advancedSearch": "Avansert søk",
		"allLocations": "Alle steder",
		"cancelled": "Annullert",
		"consigneeReference": "Mottakers referanse",
		"customersReference": "Kundereferanse",
		"deliveryStatus": "Leveringsstatus",
		"economicalStatus": "Økonomisk status",
		"economicalStatusSelected": "Alle økonomisk statuser | {count} økonomisk status valgt | {count} økonomisk status valgt",
		"editSearch": "Rediger søket",
		"fromDespatchParty": "Henteaddresse",
		"goodsTypes": "Godstyper",
		"incomplete": "Ufullstendig",
		"invoiced": "Oppgjort",
		"loading": "Henter oppdrag...",
		"notDelivered": "Ikke levert",
		"notPickedUp": "Ikke hentet",
		"notSettled": "Ikke klarert",
		"onlyDelivered": "Bare levert",
		"onlyPickedUp": "Bare hentet",
		"orderDetails": "Detaljer Oppdrag",
		"orderType": "Oppdragstype",
		"pickupStatus": "Hentestatus",
		"poReference": "PO referanse",
		"recorded": "Bokført",
		"references": "Referanser",
		"referencesSelected": "Alle referanser | {count} referanse valgt | {count} referanser valgt",
		"resetSearch": "Nullstill søk",
		"saveSearch": "Lagre dette søket",
		"search": "Søk",
		"searchForLocation": "Søk etter sted",
		"searchForOrders": "Søk etter Oppdrag",
		"searchPlaceholder": "Søketekst",
		"selectDate": "Velg dato",
		"selectEconomicalStatus": "Velg økonomisk status",
		"selectReferences": "Velg referanser",
		"sendersReference": "Avsenders referanse",
		"settled": "Klarert",
		"showAny": "Vis alle",
		"toDeliveryParty": "Leveringsaddresse",
		"failedToFetch": "Kunne ikke søke etter ordre",
		"selectOrdersFromArea": "Velg ordre fra område",
		"selectOrdersToArea": "Velg ordre til område",
		"etd": "ETD",
		"eta": "ETA",
		"etx": "ETD / ETA",
		"selectOrderStatus": "Velg status",
		"orderStatusSelected": "Alle statuser | {count} status valgt | {count} statuser valgt",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"waybillNumber": "Fraktbrevnr",
		"allWaybillNumbers": "Alle fraktbrevnr",
		"inboundEdiFilterLabel": "Bare inngående EDI fra",
		"inboundEdiFilterPlaceholder": "EDI fra",
		"deviationFilterLabel": "Avvik"
	}
}
</i18n>
<template>
	<t-vertical-panel>
		<template #header>
			<div class="order-search-header">
				<t-header-select
					:items="savedSearches"
					:selectedItem="loadedSearch"
					width="100%"
					icon="search"
					@change="onLoadSavedSearch"
				>
					<template>
						{{ loadedSearch.id === -1 ? $t('searchForOrders') : loadedSearch.label}}
					</template>
					<template #menuitemlabel="{item}">
						{{ item.labelKey ? $t(item.labelKey) : item.label }}
					</template>
				</t-header-select>
			</div>
		</template>

		<template #sub-header>
			<div class="order-search-sub-header">
				<t-button
					:busy="ordersLoading"
					appearance="primary"
					width="100%"
					@click="searchOrders"
				>
					{{orderSearchText}}
				</t-button>
				<t-button
					appearance="minimal"
					width="100%"
					type="bp"
					iconBefore="filter-keep"
					@click="showSaveSearch"
				>
					{{loadedSearch.id === -1 ? $t('saveSearch') : $t('editSearch')}}
				</t-button>
			</div>
		</template>

		<div class="order-search-content">
			<t-selectable-form-group
				:items="dateTypes"
				:selectedItem="searchFilter.dateType"
				horizontal
				@change="setSearchFilterDateType"
			>
				<template #label="{item}">
					{{ $t(item) }}
				</template>
				<template #menuitemlabel="{item}">
					{{ $t(item) }}
				</template>

				<t-date-picker
					:placeholder="$t('selectDate')"
					:dateFormat="displayDateFormat"
					:value="formatDate(searchFilter.date.from)"
					width="100%"
					relative
					@input="setSearchFilterDateFrom"
					@enter="searchOrders"
				/>
				<t-date-picker
					:placeholder="$t('selectDate')"
					:dateFormat="displayDateFormat"
					:value="formatDate(searchFilter.date.to)"
					width="100%"
					relative
					@input="setSearchFilterDateTo"
					@enter="searchOrders"
				/>
			</t-selectable-form-group>

			<t-form-group>
				<LocationsCombobox
					ref="fromDespatchParty"
					:label="$t('fromDespatchParty')"
					:placeholder="$t('searchForLocation')"
					:selected="searchFilter.fromDespatchParty"
					:dialogTitle="$t('selectOrdersFromArea')"
					dialogType="fromDespatchParty"
					width="100%"
					iconSize="sm"
					icon="geosearch"
					@input="inputs.fromDespatchParty = $event"
					@select="onSelectDespatchParty"
					@multiselect="setFromDespatchParty"
					@enter="searchOrders"
				/>
				<t-tag-container
					v-if="hasItems(searchFilter.fromDespatchParty)"
					:items="searchFilter.fromDespatchParty"
					displayKey="label"
					@change="setFromDespatchParty"
					@tag-click="changeTagOpCode({ key: 'fromDespatchParty', tag: $event })"
				>
					<template v-slot="{ item }">
						<t-location-tag-inner :item="item" displayKey="label" />
					</template>
				</t-tag-container>
			</t-form-group>

			<t-form-group>
				<LocationsCombobox
					ref="toDeliveryParty"
					:label="$t('toDeliveryParty')"
					:placeholder="$t('allLocations')"
					:selected="searchFilter.toDeliveryParty"
					:dialogTitle="$t('selectOrdersToArea')"
					dialogType="toDeliveryParty"
					width="100%"
					iconSize="sm"
					icon="geosearch"
					@input="inputs.toDeliveryParty = $event"
					@select="onSelectDeliveryParty"
					@multiselect="setToDeliveryParty"
					@enter="searchOrders"
				/>
				<t-tag-container
					v-if="hasItems(searchFilter.toDeliveryParty)"
					:items="searchFilter.toDeliveryParty"
					displayKey="label"
					@change="setToDeliveryParty"
					@tag-click="changeTagOpCode({ key: 'toDeliveryParty', tag: $event })"
				>
					<template v-slot="{ item }">
						<t-location-tag-inner :item="item" displayKey="label" />
					</template>
				</t-tag-container>
			</t-form-group>

			<t-form-group>
				<customer-search-input
					ref="customer"
					:selectedItems="searchFilter.customer"
					width="100%"
					@input="inputs.customer = $event"
					@change="addCustomerString"
					@select="addCustomer"
					@enter="searchOrders"
					@set:selected="setCustomer"
				/>
				<t-tag-container
					v-if="hasItems(searchFilter.customer)"
					:items="searchFilter.customer"
					displayKey="name"
					@change="setCustomer"
					@tag-click="changeTagOpCodeBetweenNotAndOr({ key: 'customer', tag: $event })"
				>
					<template v-slot="{ item }">
						<t-location-tag-inner :item="item" displayKey="name" />
					</template>
				</t-tag-container>
			</t-form-group>

			<t-form-group >
				<goods-types-select
					:label="$t('goodsTypes')"
					:selectedItems="searchFilter.goodsTypes"
					@change="addGoodsType"
				/>
				<t-tag-container
					v-if="hasItems(searchFilter.goodsTypes)"
					:items="searchFilter.goodsTypes"
					displayKey="name"
					@change="setGoodsType"
				/>
			</t-form-group>

			<t-form-group>
				<order-types-select
					:label="$t('orderType')"
					:selectedItems="searchFilter.orderTypes"
					@change="addOrderTypes"
				/>
				<t-tag-container
					v-if="hasItems(searchFilter.orderTypes)"
					:items="searchFilter.orderTypes"
					displayKey="name"
					@change="setOrderTypes"
				/>
			</t-form-group>

			<OperationalStatusFormInput
				:selectedItems="searchFilter.orderStatus"
				relative
				@change="addOrderStatus"
			>
				<template v-slot:displayedValue="{popoverShow}">
					{{ popoverShow ? $t('selectOrderStatus') : $tc('orderStatusSelected', searchFilter.orderStatus.length)}}
				</template>
				<template #after>
					<t-tag-container
						v-if="hasItems(searchFilter.orderStatus)"
						:items="searchFilter.orderStatus"
						@change="setOrderStatus"
					>
						<template v-slot="{item}">
							<div style="display: flex; align-items: center; justify-content: flex-start;">
								<t-status-color-dot :color="getStatusColor(item)"/>
								<div style="margin-left: 5px;">{{getStatusText(item)}}</div>
							</div>
						</template>
					</t-tag-container>
				</template>
			</OperationalStatusFormInput>

			<t-form-group>
				<t-select
					:items="hasAtdItems"
					:label="$t('pickupStatus')"
					:selectedItem="searchFilter.hasAtd"
					width="100%"
					displayName="label"
					relative
					@change="setHasAtd"
				>
					<template #displayedValue>
						{{$t(searchFilter.hasAtd.label)}}
					</template>
					<template #optionItemValue="slotProps">
						{{$t(slotProps.item.label)}}
					</template>
				</t-select>
			</t-form-group>

			<t-form-group>
				<t-select
					:items="hasAtaItems"
					:label="$t('deliveryStatus')"
					:selectedItem="searchFilter.hasAta"
					width="100%"
					displayName="label"
					relative
					@change="setHasAta"
				>
					<template #displayedValue>
						{{$t(searchFilter.hasAta.label)}}
					</template>
					<template #optionItemValue="{ item }">
						{{$t(item.label)}}
					</template>
				</t-select>
			</t-form-group>

			<EconomicalStatusesFormInput
				:selectedItems="searchFilter.economicalStatus"
				relative
				@change="addEconomicalStatus"
			>
				<template v-slot:displayedValue="{popoverShow}">
					{{ popoverShow ? $t('selectEconomicalStatus') : $tc('economicalStatusSelected', searchFilter.economicalStatus.length)}}
				</template>
				<template #after>
					<t-tag-container
						v-if="hasItems(searchFilter.economicalStatus)"
						:items="searchFilter.economicalStatus"
						@change="setEconomicalStatus"
					>
						<template v-slot="{item}">
							<div style="display: flex; align-items: center; justify-content: flex-start;">
								<t-status-color-dot :color="getEconomicalStatusColor(item)"/>
								<div style="margin-left: 5px;">{{getEconomicalStatus(item)}}</div>
							</div>
						</template>
					</t-tag-container>
				</template>
			</EconomicalStatusesFormInput>

			<t-form-group>
				<t-select
					:items="references"
					:label="$t('references')"
					:selectedItems="searchFilter.references"
					width="100%"
					relative
					@change="addReferences"
				>
					<template #displayedValue="{popoverShow}">
						{{ popoverShow ? $t('selectReferences') : $tc('referencesSelected', searchFilter.references.length)}}
					</template>
					<template #optionItemValue="{ item }">
						{{$t(item.id)}}
					</template>
				</t-select>
				<t-tag-container
					v-if="hasItems(searchFilter.references)"
					:items="searchFilter.references"
					@change="setReferences"
				>
					<template #default="{item}">
						{{$t(item.id)}}
					</template>
				</t-tag-container>
				<t-text-input
					:value="searchFilter.referencesText"
					:placeholder="$t('searchPlaceholder')"
					@input="setReferencesText"
					@keyup.enter="searchOrders"
				/>
			</t-form-group>

			<t-form-group>
				<t-search-input
					ref="waybillNumbers"
					:label="$t('waybillNumber')"
					:placeholder="$t('allWaybillNumbers')"
					@input="inputs.waybillNumber = $event"
					@change="addWaybillNumber"
					@enter="searchOrders"
				/>
				<t-tag-container
					v-if="hasItems(searchFilter.waybillNumber)"
					:items="searchFilter.waybillNumber"
					@change="setWaybillNumber"
				>
					<template v-slot="{item}">
						{{item.id}}
					</template>
				</t-tag-container>
			</t-form-group>

			<t-form-group>

				<t-checkbox
					:value="searchFilter.mustHaveInboundEdi"
					:checked="searchFilter.mustHaveInboundEdi"
					:label="$t('inboundEdiFilterLabel')"
					style="margin-bottom: 0"
					@change="setMustHaveInboundEdi"
				/>

				<t-search-input
					:value="searchFilter.inboundEdi"
					:placeholder="$t('inboundEdiFilterPlaceholder')"
					@input="setInboundEdi"
					@enter="searchOrders"
				/>
			</t-form-group>

			<t-form-group>
				<t-checkbox
					:value="searchFilter.mustHaveDeviation"
					:checked="searchFilter.mustHaveDeviation"
					:label="$t('deviationFilterLabel')"
					style="margin-bottom: 0"
					@change="setMustHaveDeviation"
				/>
			</t-form-group>

			<t-form-group :title="$t('advancedSearch')">
				<t-button type="bp" iconBefore="add" appearance="minimal">{{$t('addFilter')}}</t-button>
			</t-form-group>
		</div>

		<template #dialogs>
			<save-search
				:isShown="saveSearchVisible"
				:searchFilter="searchFilter"
				:loadedSearch="savedSearch"
				@close="hideSaveSearch"
				@delete="onDeleteSavedSearch"
			/>
		</template>
	</t-vertical-panel>
</template>

<script>
import { mapDynamicState, mapDynamicActions } from '@/core/mapDynamic';
import {
	displayDateFormat, goodsTypesIcons, displayDateFormatter, eventBus, statuses
} from '@/core';
import { mapState as savedSearchState } from '@/modules/saveOrderSearch/store/saveOrderSearch.store.js';
import SaveSearch from '@/modules/saveOrderSearch/SaveSearch';
import CustomerSearchInput from '@/modules/customers/CustomerSearchInput';
import GoodsTypesSelect from '@/modules/goodsTypes/GoodsTypesSelect';
import OrderTypesSelect from '@/modules/orderTypes/OrderTypesSelect';
import LocationsCombobox from '@/modules/locations/LocationsCombobox';
import OperationalStatusFormInput from '@/modules/operationalStatus/OperationalStatusFormInput';
import EconomicalStatusesFormInput from '@/modules/economicalStatuses/EconomicalStatusesFormInput';
import TCheckbox from '@/components/evergreen/inputs/TCheckbox';

export default {
	name: 'OrderSearchFilters',
	components: {
		TCheckbox,
		SaveSearch,
		CustomerSearchInput,
		GoodsTypesSelect,
		OrderTypesSelect,
		LocationsCombobox,
		OperationalStatusFormInput,
		EconomicalStatusesFormInput,
	},
	data() {
		return {
			saveSearchVisible: false,
			customerValue: '',
			hasAtdItems: [
				{ value: undefined, label: 'showAny' },
				{ value: true, label: 'onlyPickedUp' },
				{ value: false, label: 'notPickedUp' },
			],
			hasAtaItems: [
				{ value: undefined, label: 'showAny' },
				{ value: true, label: 'onlyDelivered' },
				{ value: false, label: 'notDelivered' },
			],
			references: [
				{ id: 'consigneeReference' },
				{ id: 'customersReference' },
				{ id: 'poReference' },
				{ id: 'sendersReference' },
			],
			inputs: {
				fromDespatchParty: '',
				toDeliveryParty: '',
				customer: '',
				waybillNumber: ''
			},
		};
	},
	computed: {
		...mapDynamicState('computedStoreNamespace', [
			'searchFilter',
			'ordersLoading',
			'loadedSearch',
			'dateTypes'
		]),
		...savedSearchState(['savedSearches',]),
		displayDateFormat() {
			return displayDateFormat;
		},
		orderSearchText() {
			return this.ordersLoading ? this.$t('loading') : this.$t('search');
		},
		searchId() {
			return this.$route.params.searchId || -1;
		},
		savedSearch() {
			if (Array.isArray(this.savedSearches))
				return this.savedSearches.find(x => x.id === this.searchId);
			return {};
		},
		computedStoreNamespace() {
			return `orderSearch/${this.searchId}`;
		},
	},
	watch: {
		savedSearch(newValue,oldValue) {
			if (this.loadedSearch && newValue && this.loadedSearch.id === newValue.id) {
				this.performFetchOrders();
			} else if ( (oldValue === undefined && newValue !== undefined) ||
				(oldValue && newValue && oldValue.id !== newValue.id) ) {
				this.loadSavedAndSearch();
			} else if (newValue === undefined && this.searchId !== -1) {
				this.$router.replace({ name: 'orderSearch' });
			}
		}
	},
	created() {
		eventBus.$on('refreshOrderList', this.performFetchOrders);
		this.$store.subscribeAction( (action) => {
			if (action.type === 'saveOrderSearch/addSavedSearch') {
				this.loadSavedSearch(this.savedSearch);
			}
		});
	},
	mounted() {
		if (!this.savedSearch && this.searchId !== -1) this.$router.replace({ name: 'orderSearch' });
		if (this.searchId !== this.loadedSearch.id) this.loadSavedAndSearch();
		else if (this.searchId === this.loadedSearch.id) this.performFetchOrders();
	},
	beforeDestroy() {
		eventBus.$off('refreshOrderList');
	},
	methods: {
		...mapDynamicActions('computedStoreNamespace', [
			'fetchOrders',
			'setSearchFilterDateFrom',
			'setSearchFilterDateTo',
			'setSearchFilterDateType',
			'addFromDespatchParty',
			'addFromDespatchPartyString',
			'setFromDespatchParty',
			'addToDeliveryParty',
			'addToDeliveryPartyString',
			'setToDeliveryParty',
			'addCustomer',
			'addCustomerString',
			'setCustomer',
			'addGoodsType',
			'setGoodsType',
			'addOrderTypes',
			'setOrderTypes',
			'setHasAtd',
			'setHasAta',
			'addEconomicalStatus',
			'setEconomicalStatus',
			'addOrderStatus',
			'setOrderStatus',
			'loadSavedSearch',
			'addInputTagsOnSearch',
			'addReferences',
			'setReferences',
			'setReferencesText',
			'addWaybillNumber',
			'setWaybillNumber',
			'changeTagOpCode',
			'changeTagOpCodeBetweenNotAndOr',
			'setMustHaveInboundEdi',
			'setInboundEdi',
			'setMustHaveDeviation',
		]),
		async searchOrders() {
			this.$emit('hide');
			this.addInputTagsOnSearch(this.inputs);
			this.$refs.fromDespatchParty.clearInput();
			this.$refs.toDeliveryParty.clearInput();
			this.$refs.customer.clearInput();
			this.performFetchOrders();
		},
		async performFetchOrders() {
			try {
				await this.fetchOrders();
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToFetch')
				});
			}
		},
		onSelectDespatchParty(location) {
			
			if (typeof location === 'string') {
				this.addFromDespatchPartyString(location);
				
			} else {
				this.addFromDespatchParty(location);
			}
		},
		onSelectDeliveryParty(location) {
			
			if (typeof location === 'string') {
				this.addToDeliveryPartyString(location);
				
			} else {
				this.addToDeliveryParty(location);
			}
		},
		showSaveSearch() {
			this.saveSearchVisible = true;
		},
		hideSaveSearch() {
			this.saveSearchVisible = false;
		},
		hasItems(array) {
			return array && array.length;
		},
		loadSavedAndSearch() {
			this.loadSavedSearch(this.savedSearch);
			this.searchOrders();
		},
		onDeleteSavedSearch() {
			this.hideSaveSearch();
			this.$router.push({ name: 'orderSearch' });
		},
		onLoadSavedSearch(item) {
			if (!item) return;
			if (item.id === -1) {
				this.$router.push({ name: 'orderSearch' });
			} else {
				this.$router.push({
					name: 'savedOrderSearch',
					params: { searchId: item.id }
				});
			}
		},
		getGoodsTypeIcon(goodsType) {
			return goodsTypesIcons(goodsType);
		},
		formatDate(date) {
			return displayDateFormatter(date);
		},
		getStatusText(status) {
			return this.$t(statuses.operational(status));
		},
		getStatusColor(status) {
			return statuses.color(status);
		},
		getEconomicalStatus(value) {
			return this.$t(statuses.economical(value));
		},
		getEconomicalStatusColor(value) {
			return statuses.economicalStatusColor(value);
		},
	},
};
</script>

<style lang="scss" scoped>
.order-search-header {
	display:flex;
	align-items: center;
	height: 100%;
}

.order-search-sub-header {
	display:inline-grid;
	grid-auto-flow: column;
	grid-auto-columns: 1fr;
	column-gap: 20px;
	padding: 0px 15px;
	height: 100%;
	width: calc(100% - 30px);
	align-items: center;
}

.order-search-content {
	display: grid;
	grid-auto-rows: minmax(min-content, max-content);
	row-gap: 20px;
	background: white;
	box-sizing: border-box;
	min-height: 100%;
	padding: 10px 15px 10px 15px;
}
</style>
